import { render, staticRenderFns } from "./ParametricSort.vue?vue&type=template&id=9e6bfe3a"
import script from "./ParametricSort.vue?vue&type=script&lang=js"
export * from "./ParametricSort.vue?vue&type=script&lang=js"
import style0 from "./ParametricSort.vue?vue&type=style&index=0&id=9e6bfe3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports